/* src/app/main/pages/services/ocean-service/ocean-service.component.css */
/*# sourceMappingURL=ocean-service.component.css.map */
